<template>
  <div>
    <v-card class="card_container mx-auto" style="z-index: 0">
      <v-card-title
        style="background-color: #82a1d0; position: sticky; top: 0; z-index: 0"
        background-color="primary"
        class="d-flex justify-space-between align-center"
      >
        <v-text-field
          dense
          solo
          v-model="search"
          append-icon="mdi-magnify"
          :label="$tc('commons.search')"
          single-line
          hide-details
          class="search"
        />
        <v-col cols="auto" class="my-n2">
          <v-row v-show="showConfig && showAdd">
            <!-- Título -->
            <h3 class="secondary--text mr-4 my-auto" v-show="title">
              {{ title }}
            </h3>
            <v-row class="justify-start border ma-0">
              <!-- Botón de Refresh -->
              <v-col cols="auto" class="pa-0">
                <v-tooltip bottom v-if="showRefresh">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="refreshItems"
                      class="btn-table ma-1"
                      small
                    >
                      <v-icon
                        :class="{ loader: loading4 }"
                        :loading="loading4"
                        :disabled="loading4"
                        id="icon-add"
                        class="mx-auto"
                        size="19"
                      >
                        fas fa-sync-alt
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $tc("commons.refresh") }}</span>
                </v-tooltip>
              </v-col>

              <!-- Botón de Configurar Columnas -->
              <v-col cols="auto pa-0" v-show="showConfig">
                <div class="d-flex justify-center">
                  <v-dialog
                    v-model="btnConfigColumns.menu"
                    max-width="400px"
                    @keydown.esc="toggleColumnMenu"
                    offset-x
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="white"
                            dark
                            icon
                            @click="toggleColumnMenu"
                            v-bind="attrs"
                            v-on="on"
                            class="btn-table ma-1"
                            small
                          >
                            <v-icon size="20">{{
                              btnConfigColumns.icon
                            }}</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ btnConfigColumns.tooltip }}</span>
                      </v-tooltip>
                    </template>
                    <v-card>
                      <v-text-field
                        v-model="columnFilter"
                        placeholder="Buscar columnas"
                        outlined
                        dense
                        hide-details
                        class="pa-2 pb-0 ma-0"
                      ></v-text-field>
                      <div
                        style="
                          min-width: 250px;
                          max-height: 250px;
                          overflow-y: scroll;
                          scrollbar-width: unset;
                        "
                        class="pa-2 pb-0 ma-0"
                        hide-details
                      >
                        <div
                          v-if="filteredColumns?.length === 0"
                          class="text-center px-2 pb-2"
                        >
                          <span
                            >No hay resultados que coincidan con la
                            búsqueda</span
                          >
                        </div>
                        <div v-else>
                          <div
                            v-for="column in filteredColumns"
                            :key="column.field"
                            hide-details
                          >
                            <v-checkbox
                              v-model="column.visible"
                              :label="column.text"
                              hide-details
                              class="my-auto mb-2"
                            ></v-checkbox>
                          </div>
                        </div>
                      </div>
                      <v-card-actions class="d-flex justify-space-between">
                        <v-btn class="bt-exit" @click="toggleColumnMenu">
                          <v-icon>fas fa-times</v-icon>
                        </v-btn>

                        <v-btn
                          color="bt-acept"
                          @click="
                            headersUpdated();
                            toggleColumnMenu();
                          "
                        >
                          <v-icon>fas fa-save</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </v-col>

              <!-- Botón de Añadir -->
              <v-col cols="auto pa-0">
                <div v-show="showAdd">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="white"
                        dark
                        icon
                        class="btn-table ma-1"
                        small
                      >
                        <v-icon
                          size="20"
                          class="mx-auto"
                          id="icon-add"
                          v-bind="attrs"
                          v-on="on"
                          @click="openDialog('add')"
                        >
                          fas fa-plus
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $tc("commons.add") }}</span>
                  </v-tooltip>
                </div>
              </v-col>

              <!-- Botón de Reutilizar segmento -->
              <v-col cols="auto pa-0">
                <div v-show="showReuse">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="white"
                        dark
                        icon
                        class="btn-table ma-1"
                        small
                      >
                        <v-icon
                          size="20"
                          class="mx-auto"
                          id="icon-add"
                          v-bind="attrs"
                          v-on="on"
                          @click="openDialog('reuse')"
                        >
                          fas fa-recycle
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $tc("schedules.reuseSegment") }}</span>
                  </v-tooltip>
                </div>
              </v-col>

              <!-- Botón de Validar proceso -->
              <v-col cols="auto pa-0">
                <div v-if="showValidateProcess" class="mx-2">
                  <v-tooltip bottom class="ma-2">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        size="30"
                        color="white"
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialog('validate')"
                      >
                        mdi-sort-bool-ascending-variant
                      </v-icon>
                    </template>
                    <span>{{ $tc("workflow.validateProcess") }}</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-row>
        </v-col>

        <div v-if="showFilterLabels">
          <v-autocomplete
            v-model="selected"
            small-chips
            dense
            solo
            hide-details
            append-icon="mdi-tag-multiple"
            :label="$tc('commons.group')"
            class="autocomplete"
            :items="tags"
            item-text="text"
            item-value="id"
            multiple
            @input="changesLabels()"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                v-if="index < 1"
                :color="item.color"
                id="chip-label"
                small
                close
                @click:close="selected.splice(index, 1)"
              >
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text text-caption">
                (+ {{ selected.length - 1 }} )
              </span>
            </template>
            <template v-slot:item="{ item }">
              <v-chip id="chip-label" small :color="item.color">
                {{ item.text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </div>
      </v-card-title>

      <v-divider></v-divider>
      <v-data-table
        :search="search"
        :hide-default-footer="true"
        :disable-pagination="!showPagination"
        :page.sync="currentPage"
        :items-per-page="showPagination ? itemsPerPage : -1"
        @page-count="pageCount = $event"
        :headers="visibleHeaders"
        :items="filterForLabels"
        style="min-width: 100%"
        :calculate-widths="true"
        @click:row="goToItem"
        v-sortable-columns="saveColumnOrder"
        :key="tableKey"
        item-key="index"
        fixed-header
        :height="calculateMaxHeight"
      >
        <template v-slot:header.actions="{ header }">
          <span class="d-flex justify-center">
            {{ header.text }}
          </span>
        </template>
        <template v-slot:item.labels="{ item }">
          <div class="ma-0 pa-0">
            <v-chip
              id="chip-label"
              class="ma-1"
              v-for="label in item.labels"
              :key="label.etiquetaId"
              small
              :color="label.color"
            >
              {{ label.nombre }}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.roles="{ item }">
          <div class="ma-0 pa-0">
            <v-chip
              class="ma-1"
              v-for="rol in item.roles"
              :key="rol.rolId"
              small
            >
              {{ rol.rolNombre }}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.color="{ item }">
          <div
            class="mx-auto"
            style="width: 25px; height: 25px"
            :style="{ backgroundColor: item.color }"
          />
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-space-around">
            <v-tooltip bottom v-if="operator">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" v-show="localShowEdit">
                  <v-btn icon>
                    <v-icon
                      id="icon-edit"
                      @click="openDialog('changedPass', item, $event)"
                    >
                      fas fa-key
                    </v-icon>
                  </v-btn>
                </span>
              </template>
              <span>{{ $tc("commons.changedPass") }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="showInicializeCC">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" v-show="localShowEdit">
                  <v-btn icon>
                    <v-icon
                      id="icon-edit"
                      @click="openDialog('inicializeCC', item, $event)"
                    >
                      fas fa-angle-double-up
                    </v-icon>
                  </v-btn>
                </span>
              </template>
              <span>{{ $tc("commons.initializeMassiveCC") }}</span>
            </v-tooltip>
            <div v-if="isRegistrations" class="pa-0 ma-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" v-show="localShowEdit">
                    <v-btn icon>
                      <v-icon
                        id="icon-edit"
                        :disabled="
                          !verifyExistingAction('accion:modificarregistracion')
                        "
                        @click="openDialog('edit', item, $event)"
                      >
                        fas fa-pen
                      </v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>{{ $tc("commons.edit") }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" v-show="showDelete">
                    <v-btn v-if="asegurable === ''" icon>
                      <v-icon
                        id="icon-delete"
                        :disabled="
                          !verifyExistingAction('accion:eliminarregistracion')
                        "
                        @click="openDialog('delete', item, $event)"
                      >
                        fas fa-trash
                      </v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>{{ $tc("commons.delete") }}</span>
              </v-tooltip>
            </div>
            <div v-else class="pa-0 ma-0">
              <v-tooltip bottom v-if="!pcas">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" v-show="localShowEdit">
                    <v-btn
                      :disabled="shouldShowDeleteButton(item)"
                      icon
                      :plain="shouldShowDeleteButton(item)"
                    >
                      <v-icon
                        id="icon-edit"
                        :disabled="
                          !(
                            item.permission === 'P' ||
                            item.permission === 'C' ||
                            item.permission === undefined ||
                            item.permission === null
                          )
                        "
                        @click="openDialog('edit', item, $event)"
                      >
                        fas fa-pen
                      </v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>{{ $tc("commons.edit") }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-btn class="center" v-show="showDelRelation" icon>
                      <v-icon
                        id="icon-delete-relation"
                        @click="openDialog('deleteRelation', item)"
                      >
                        fas fa-trash
                      </v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>{{ $tc("commons.deleteRelation") }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" v-show="showDelete">
                    <v-btn
                      v-if="asegurable !== ''"
                      icon
                      :plain="shouldShowDeleteButton(item)"
                    >
                      <v-icon
                        :disabled="!verifyExistingAction(asegurable)"
                        id="icon-delete"
                        @click="openDialog('delete', item, $event)"
                      >
                        fas fa-trash
                      </v-icon>
                    </v-btn>
                    <v-btn
                      v-if="asegurable === ''"
                      :disabled="shouldShowDeleteButton(item)"
                      icon
                      :plain="shouldShowDeleteButton(item)"
                    >
                      <v-icon
                        id="icon-delete"
                        :disabled="
                          !(
                            item.permission === 'P' ||
                            item.permission === undefined ||
                            item.permission === null
                          )
                        "
                        @click="openDialog('delete', item, $event)"
                      >
                        fas fa-trash
                      </v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>{{ $tc("commons.delete") }}</span>
              </v-tooltip>
            </div>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" v-show="showFiles">
                  <v-btn
                    :disabled="shouldShowDeleteButton(item)"
                    icon
                    :plain="shouldShowDeleteButton(item)"
                  >
                    <v-icon
                      id="icon-edit"
                      @click="openDialog('files', item, $event)"
                    >
                      fa-eye
                    </v-icon>
                  </v-btn>
                </span>
              </template>
              <span>{{ $tc("commons.see") }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="showIcon">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <div>
                    <v-img
                      src="../../assets/icons/actualizar.png"
                      style="cursor: pointer"
                      alt="eliminar"
                      max-width="25"
                      class="mt-2 mr-3"
                      :disabled="
                        !(
                          item.permission === 'P' ||
                          item.permission === 'C' ||
                          item.permission === 'L' ||
                          item.permission === undefined ||
                          item.permission === null
                        )
                      "
                      @click="openDialog('exe', item, $event)"
                      v-if="executeButtonEnabled(item)"
                    />
                  </div>
                </span>
              </template>
              <span>{{ $tc("reports.exe") }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="showIcon">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-btn icon>
                    <v-icon
                      id="icon-edit"
                      :disabled="
                        !(
                          item.permission === 'P' ||
                          item.permission === undefined ||
                          item.permission === null
                        )
                      "
                      @click="openDialog('pass', item, $event)"
                    >
                      fas fa-user-lock
                    </v-icon>
                  </v-btn>
                </span>
              </template>
              <span>{{ $tc("reports.assignPasses") }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <div v-if="showPagination && pageCount > 1" class="mt-2">
      <v-pagination
        v-model="currentPage"
        :length="pageCount"
        prev-icon="mdi-chevron-left"
        next-icon="mdi-chevron-right"
        hide-delimiter-background
        :total-visible="10"
      />
    </div>
  </div>
</template>

<script>
import ToolbarTitles from "./ToolbarTitles.vue";
import Sortable from "sortablejs";
export default {
  components: { ToolbarTitles },
  props: {
    executeButtonEnabled: Function,
    headers: [Array, Object],
    items: Array,
    title: String,
    goToItem: {
      type: Function,
      default: () => {},
    },
    openDialog: Function,
    showDelRelation: {
      type: Boolean,
      default: false,
    },
    showReuse: {
      type: Boolean,
      default: false,
    },
    showRefresh: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showAdd: {
      type: Boolean,
      default: true,
    },
    showConfig: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    showFiles: {
      Boolean,
      default: false,
    },
    showPagination: {
      type: Boolean,
      default: false,
    },
    itemsPerPage: {
      type: Number,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    showValidateProcess: {
      type: Boolean,
      default: false,
    },
    showFilterLabels: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
    },
    operator: {
      type: Boolean,
      default: false,
    },
    pcas: {
      type: Boolean,
      default: false,
    },
    showInicializeCC: {
      type: Boolean,
      default: false,
    },
    asegurable: {
      type: String,
      default: "",
    },
    heightTable: {
      type: String,
      default: "60vh",
    },
    isRegistrations: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageCount: 0,
      selected: [],
      search: "",
      localShowEdit: this.showEdit,
      currentPage: 1,
      tableKey: 0,
      btnConfigColumns: {
        menu: false,
        icon: "fas fa-cog",
        tooltip: "Columnas",
      },
      columnFilter: "",
      localHeaders: this.headers?.map((header) => ({ ...header })),
      loader: null,
      loading4: false,
    };
  },
  watch: {
    headers: {
      handler(newHeaders) {
        this.localHeaders = newHeaders.map((header) => ({ ...header }));
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    signed() {
      return this.$store.state.gestionTiempos.signed;
    },
    filterForLabels() {
      if (this.selected.length > 0) {
        return this.changesLabels();
      } else {
        return this.items;
      }
    },
    filteredItems() {
      const filtered = this.search
        ? this.items.filter((item) =>
            item.name.toLowerCase().includes(this.search.toLowerCase()),
          )
        : this.items;
      if (this.showPagination && this.itemsPerPage) {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        return filtered.slice(start, start + this.itemsPerPage);
      }
      return filtered;
    },
    calculateMaxHeight() {
      switch (true) {
        case this.items?.length > 5:
          return this.heightTable;
      }
    },
    filteredColumns() {
      const filterText = this.columnFilter.toLowerCase();
      return this.localHeaders?.filter((column) => {
        return column.text?.toLowerCase().includes(filterText);
      });
    },
    visibleHeaders() {
      return this.localHeaders?.filter((column) => column.visible);
    },
  },
  methods: {
    verifyExistingAction(accion) {
      if (typeof localStorage !== "undefined") {
        const asegurables =
          JSON.parse(localStorage.getItem("asegurables")) || [];
        return asegurables.includes(accion);
      }

      return false;
    },

    async refreshItems() {
      this.loading4 = true;
      try {
        await this.$emit("refreshItems");
      } finally {
        setTimeout(() => {
          this.loading4 = false;
        }, 2000);
      }
    },

    changesLabels() {
      let filteredItems = this.items?.filter((item) => {
        return this.selected?.every((selectedId) => {
          return item.labels?.some((label) => {
            return label.etiquetaId === selectedId;
          });
        });
      });
      return filteredItems;
    },

    headersUpdated() {
      this.$emit("headersUpdated", this.localHeaders);
    },

    toggleColumnMenu() {
      this.btnConfigColumns.menu = !this.btnConfigColumns.menu;
    },
    shouldShowDeleteButton(item) {
      return item.editable === undefined ? false : item.editable;
    },
    saveColumnOrder(newIndex, oldIndex) {
      const visibleHeaders = this.localHeaders.filter(
        (header) => header.visible,
      );
      const movedColumn = visibleHeaders.splice(oldIndex, 1)[0];
      visibleHeaders.splice(newIndex, 0, movedColumn);
      const newHeaders = [];
      let visibleIndex = 0;
      for (const header of this.localHeaders) {
        if (header.visible) {
          newHeaders.push(visibleHeaders[visibleIndex]);
          visibleIndex++;
        } else {
          newHeaders.push(header);
        }
      }
      this.localHeaders = newHeaders.map((header) => ({ ...header }));
      this.tableKey++;
      this.$forceUpdate();
    },
  },
  directives: {
    sortableColumns: {
      inserted(el, binding) {
        const table = el.querySelector("table");
        const headerRow = table.querySelector("thead tr");
        const sortableHeaders = Array.from(headerRow.children);
        const options = {
          animation: 150,
          ghostClass: "sortable-ghost",
          onEnd: function (event) {
            const newIndex = event.newIndex;
            const oldIndex = event.oldIndex;
            binding.value(newIndex, oldIndex);
          },
        };
        Sortable.create(headerRow, options);
      },
    },
  },
};
</script>

<style scoped>
.loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}
.btn-table {
  background-color: #82a1d0;
}
.card_container {
  max-width: 100%;
}
.disabled {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.5;
}
.search {
  max-width: 500px;
}
.autocomplete {
  padding: 0px;
  margin: 0px;
  max-width: 270px;
}
#chip-label {
  color: #ffffff;
  text-shadow: 0px 1px 4px #000000be;
}
#icon-add {
  color: #ffffff;
  margin-right: 8px;
}
#icon-edit {
  color: #39537a;
  font-size: 20px;
}
#icon-delete {
  color: #e2504c;
  font-size: 20px;
}
#icon-delete-relation {
  color: #e48131;
  font-size: 20px;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-next {
  background-color: #39537a !important;
  color: white !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
@media (max-width: 600px) {
  /* Cuando el tamaño de la pantalla sea menor a 600px, apilar los elementos */
  .v-card-title {
    flex-direction: column;
    align-items: flex-start;
  }

  /* Asegurarse de que el título esté encima del buscador */
  .v-text-field {
    order: 2; /* El buscador se mueve abajo */
    margin-top: 10px; /* Espaciado entre el título y el buscador */
  }

  h3 {
    order: 1; /* El título se mueve arriba */
  }
}
</style>
